module.exports = __webpack_public_path__ + "static/media/racoon_boosters.20754afb.webp";